import React from 'react'
import { Card, Row, Col, message, Typography } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../../BaseComponent'
import Filters, { FilterItem, Types } from '../../../Filters'
import PetRestoreList from '../../../PetRestoreList'
import IPet from '../../../../interfaces/IPet'

type PetRestoreProps = BaseFormComponentProps & {
  uuid: string,
  loading?: boolean,

  pagination: any,
  history: any,
  error: any | null,

  pets: Array<IPet> | null,
  loadPets: (args: any) => void,

  shelter: any | null,
  loadShelter: Function,

  dispatchRestore: (args: any) => void
}

export default class PetRestore extends FormComponent<PetRestoreProps> {

  state = {
    saving: false
  }

  private petsDispatchOptions = {
    search: {
      deleted: true,
      branch: {
        with: {
          _exists: true,
          shelter: {
            with: {
              _exists: true,
              uuid: this.props.uuid
            }
          }
        }
      }
    },
    options: {
      _force_ids: true
    }
  } as const

  static getDerivedStateFromProps(props: any, state: any) {
    if (state.saving && !props.loading) {
      state.saving = false

      if (props.error) {
        message.error(`Could not restore pet. Error: ${props.error}`)
      } else {
        message.success('Pet restored successfully!')
      }
    }

    return state
  }

  componentDidMount() {
    const { uuid, shelter, loadShelter } = this.props

    if (!shelter) {
      loadShelter({
        search: {
          uuid: uuid,
          contract_options: {
            with: true
          },
          organization_question_shelters: {
            with: {
              deleted: false,
              kiosk_reason_id: null,
              question_shelter_species: {
                with: true
              }
            }
          },
          organization_branches: {
            with: true
          }
        },
        options: {
          _force_ids: true
        }
      })
    }
  }

  handleRestore = (petUuid: string[]) => {
    const { uuid, dispatchRestore } = this.props

    if (petUuid.length > 0) {
      dispatchRestore({
        shelter_uuid: uuid,
        pet_uuid: petUuid
      })

      this.setState({
        saving: true
      })
    }
  }

  render() {
    const { uuid, loading, shelter, pets, pagination, permissions, history, loadPets } = this.props

    const branchToFilter = shelter?.organization_branches?.map(branch => {
      return {
        value: branch.id,
        text: branch.name
      }
    }) || []

    return (
      <>
        <Typography.Title level={5}>Restore deleted pets</Typography.Title>
        <Typography.Text>This tab lets you restore pets deleted by shelter/rescue staff directly in their Adopets account. It is a typical case to have a shelter complaining of an animal being available in the shelter software and not showing up because the animal had been deleted from Adopets at a previous time.</Typography.Text>
        <Card title="Filters" style={{marginBottom: 25}}>
          <Filters size="medium" defaultSubmitOptions={this.petsDispatchOptions} submitDispatch={loadPets} loading={loading}>
            {({ values, handleFilterChange }: any) => (
              <Row gutter={9}>
                <Col xs={24} md={8}>
                  <FilterItem
                    name="uuid"
                    type={Types.INPUT}
                    placeholder="UUID"
                    value={values['uuid']}
                    size="medium"
                    options={{
                      input: {
                        allowClear: true
                      }
                    }}
                    onChange={handleFilterChange}
                  />
                </Col>
                <Col xs={24} md={6}>
                  <FilterItem
                    name="branch_id"
                    loading={!shelter}
                    type={Types.SELECT}
                    placeholder="Location"
                    data={branchToFilter as any || []}
                    value={values['branch_id']}
                    size="medium"
                    options={{
                      select: {
                        allowClear: true,
                        showSearch: true
                      }
                    }}
                    onChange={handleFilterChange}
                  />
                </Col>
                <Col xs={24} md={5}>
                  <FilterItem
                    name="custom_code"
                    type={Types.INPUT}
                    placeholder="Custom Code"
                    value={values['custom_code']}
                    size="medium"
                    options={{
                      input: {
                        allowClear: true
                      }
                    }}
                    onChange={handleFilterChange}
                  />
                </Col>
                <Col xs={24} md={5}>
                  <FilterItem
                    name="global_code"
                    type={Types.INPUT}
                    placeholder="Global Code"
                    value={values['global_code']}
                    size="medium"
                    options={{
                      input: {
                        allowClear: true
                      }
                    }}
                    onChange={handleFilterChange}
                  />
                </Col>
              </Row>
            )}
          </Filters>
        </Card>

        <Card title="List of Pets">
          <PetRestoreList shelterUuid={uuid} loading={loading} pets={pets} pagination={pagination} permissions={permissions} history={history} loadPets={loadPets} onRestore={this.handleRestore} />
        </Card>
      </>
    )
  }
}
